import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Download, FileText } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function BrochureForm() {
  const [form, setForm] = useState({ name: "", email: "", organization: "", role: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast.error("Please enter your name and email to download the brochure.");
      return;
    }
    try {
      setLoading(true);
      const { data } = await axios.post(`${API}/brochure-requests`, form);
      toast.success("Brochure ready — your download will start now.");
      // Trigger PDF download
      const a = document.createElement("a");
      a.href = `${BACKEND_URL}${data.download_url}`;
      a.download = "Marpay-Biotec-Product-Brochure.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      setForm({ name: "", email: "", organization: "", role: "" });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Could not generate brochure. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={onSubmit}
      data-testid="brochure-form"
      className="grid grid-cols-1 md:grid-cols-2 gap-3 text-[var(--mp-text)]"
    >
      <input
        data-testid="brochure-input-name"
        value={form.name}
        onChange={update("name")}
        required
        placeholder="Full name *"
        className="bf-input"
      />
      <input
        data-testid="brochure-input-email"
        type="email"
        value={form.email}
        onChange={update("email")}
        required
        placeholder="Email *"
        className="bf-input"
      />
      <input
        data-testid="brochure-input-org"
        value={form.organization}
        onChange={update("organization")}
        placeholder="Hospital / Clinic / Distributor"
        className="bf-input"
      />
      <input
        data-testid="brochure-input-role"
        value={form.role}
        onChange={update("role")}
        placeholder="Role (Doctor / Distributor / PCD…)"
        className="bf-input"
      />
      <button
        type="submit"
        disabled={loading}
        data-testid="brochure-submit"
        className="md:col-span-2 inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white text-[var(--mp-text)] text-sm font-medium hover:bg-[var(--mp-gold)] transition-colors disabled:opacity-60"
      >
        {loading ? (
          <>
            <FileText className="h-4 w-4" /> Preparing PDF…
          </>
        ) : (
          <>
            <Download className="h-4 w-4" /> Download full brochure (PDF)
          </>
        )}
      </button>
      <style>{`
        .bf-input {
          background: rgba(255,255,255,0.95);
          border: 1px solid rgba(255,255,255,0.2);
          border-radius: 12px;
          padding: 0.85rem 1rem;
          font-size: 0.95rem;
          width: 100%;
          font-family: inherit;
          color: var(--mp-text);
        }
        .bf-input:focus { outline: 2px solid var(--mp-gold); }
        .bf-input::placeholder { color: var(--mp-text-2); }
      `}</style>
    </form>
  );
}
